// --- Core ---
import * as Sentry from "@sentry/react";
import {useEffect} from "react";
import {createBrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from "react-router";
// --- SaniQ ---
import config from "config";
import Package from "../../package.json";
import {currentTenant} from "helpers/Application";

Sentry.init({
  dsn: "https://1220086722c740759fe0328f916cc9a4@sentry.saniq-dev.org/20",
  enabled: config.appEnv !== "dev",
  ignoreErrors: [
    //NOTE(Keune): The AbortError and the unhandled Promise Rejection end with the same String
    /Component unmounted$/
  ],
  integrations: [
    //NOTE(Keune): Currently only supported by Chromium based browsers
    //Sentry.browserProfilingIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV7BrowserTracingIntegration ({
      createRoutesFromChildren,
      matchRoutes,
      useEffect,
      useLocation,
      useNavigationType
    }),
    Sentry.replayIntegration(
      {
        networkDetailAllowUrls: [config.apiHost]
      }
    )
  ],
  environment: config.appEnv,
  release: `${Package.name}@${Package.version}`,
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // result in 25% of transactions being profiled (0.5*0.5=0.25)
  //profilesSampleRate: 1.0,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  tracePropagationTargets: [config.apiUrl],
  replaysSessionSampleRate: config.appEnv === 'dev' ? 1.0 : 0.1,
  replaysOnErrorSampleRate: 1.0
  //sendDefaultPii: true
});
Sentry.setTag("tenant", currentTenant());
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export {
  sentryCreateBrowserRouter
};
